// src/shared/components/EmailField.tsx
import React, { useState } from "react";
import CommonTextField from "./CommonTextField";

interface EmailFieldProps {
  label?: string;
  value: string;
  onChange: (value: string, valid: boolean) => void;
  required?: boolean;
  placeholder?: string;
}

const EmailField: React.FC<EmailFieldProps> = ({ label = "Email Address", value, onChange, required = true ,placeholder = "Enter your email",}) => {
  const [error, setError] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(newValue)) {
      setError("Invalid email address");
      onChange(newValue, false);
    } else {
      setError("");
      onChange(newValue, true);
    }
  };

  return (
    <CommonTextField
      label={label}
      name="email"
      value={value}
      onChange={handleChange}
      type="email"
      required={required}
      error={!!error}
      helperText={error}
      placeholder={placeholder}
      fullWidth
    />
  );
};

export default EmailField;
